@if (loadingScreenService.loading()) {
  <app-loading-screen></app-loading-screen>
}
<router-outlet></router-outlet>
